import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { ExcelService } from '../../../services/excel/excel.service';
import { Estrategias, Objetivos, obtenerError, Perspectivas, Planificacion, procesamiento, Proyectos, Responsables } from '../../../models/Formulacion/indicadores-metas/datos';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import Swal from 'sweetalert2';
import { messages } from '../../funciones/mensajes';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { ResponsableService } from '../../../services/gestion/responsable/responsable.service';
import { ObjetivoService } from '../../../services/gestion/objetivo/objetivo.service';
import { StrategiaService } from '../../../services/gestion/strategias/strategia.service';
import { ProyectosService } from '../../../services/gestion/proyectos/proyectos.service';
import { PERMISOS } from '../../../shared/catalogos';

@Component({
  selector: 'app-alineamiento-estrategico',
  templateUrl: './alineamiento-estrategico.component.html',
  styleUrl: './alineamiento-estrategico.component.css'
})
export class AlineamientoEstrategicoComponent implements OnInit {
  public readonly permisos = PERMISOS;

  public planeacion: Planificacion[] = [];
  public perspectiva: Perspectivas[] = [];
  public objetivos: Objetivos[] = [];
  public responsable: Responsables[] = [];
  public estrategia = [];
  public proyecto = [];

  public diccionarioEst: any = [];
  public idPers: number = 0;
  public estratt: any; //para el edit
  public proyectt: any; //para el edit
  public idPlanificacion: any;

  public modal = false;
  public modal2 = false;
  public viewTablero = false;
  public skeleton = ['','','',''];

  /** Grupo de validación de datos */
  formEst = new FormGroup({
    inputName: new FormControl('', [Validators.required]),
    inputNameEdit: new FormControl('', [Validators.required]),
    selectObjetivos: new FormControl('', [Validators.required])
  }, { validators: this.nombreDuplicidad() });

  formProg = new FormGroup({
    inputNamePro: new FormControl('', [Validators.required]),
    inputNameProEdit: new FormControl('', [Validators.required]),
    liderSelect: new FormControl('', [Validators.required]),
    inputDesc: new FormControl('')
  }, { validators: this.nombreDuplicidadProg() });


  constructor(
    public dataService: DataService,
    private excelService: ExcelService,
    private cookies: CookieService,
    private translate: TranslateService,

    private planificacionService: PlanificacionService,
    private responsableService: ResponsableService,
    private objetivosService: ObjetivoService,
    private strategiaService: StrategiaService,
    private proyectosService: ProyectosService
  ) {
    this.obtData();
  }

  ngOnInit(): void { }

  private ordenarPerspe(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  /** Obtención de los datos */
  public async obtData() {
    try {
      this.idPlanificacion = Number(this.cookies.get('idInstitucion'));
      const plan = await this.planificacionService.getPlanificacionByIdGQL(this.idPlanificacion);
      this.planeacion.push({
        id: plan.id,
        nombre: plan.name,
        fecha_inicio: moment(plan.initial_date).toDate(),
        fecha_fin: moment(plan.end_date).toDate(),
        institucionId: plan.institution.id,
        isActive: plan.isActive
      });

      const responsables = await lastValueFrom(this.responsableService.getResponsable());
      this.responsable = [];
      for (const are of responsables) {
        if (are.institution.id === plan.institution.id) {
          for (const resp of are.responsibles) {
            this.responsable.push({
              id: resp.id,
              nombre: resp.position,
              //apellido_paterno: resp.first_surname,
            });
          }
        }
      }
      this.responsable = this.ordenarPerspe(this.responsable);

      await this.perPers(plan);
      this.perspectiva = this.ordenarPerspe(this.perspectiva);
      this.objetivos = this.ordenarPerspe(this.objetivos);
      this.estrategia = this.ordenarPerspe(this.estrategia);
      this.proyPer();

      this.agregadoNuevos();
      this.viewTablero = true;
    } catch (error) {
      
    }
  }
  /** Tratado y filtrado de los datos */
  public async perPers(plan: any){
    var aux = [], aux2 = [], strat = [];
    for(const per of plan.perspectives){  
      aux.push({
        nombre: per.name,
        descripcion: per.descripcion,
        planningId: plan.id,
        id: per.id,
        check: true,
      });
    }
    var objetivos = [];
    for(const per of aux){
      const res = await this.objetivosService.getObjectivesByPerspectiveGQL(Number(per.id))
      objetivos = objetivos.concat(res);
      per['objectives'] = res;
    }
    for(const obj of objetivos){
      strat = strat.concat(obj.strategies.map(s => {return s.id}));
      aux2.push({
        nombre: obj.name,
        descripcion: obj.description, 
        ponderacion: obj.weighing,
        perspectiveId: obj.perspective.id,
        perspectiva: aux.find(p => p.id === obj.perspective.id), 
        id: obj.id
      })
    }
    this.perspectiva = [];
    this.objetivos = [];
    this.perspectiva = aux;
    this.objetivos = aux2;
    for (const per of this.perspectiva) {
      this.diccionarioEst.push({ perspectiva: per, objetivos: per.objectives, estrategias: [], proyectos: [] });
    }
    
    strat = [...new Set(strat)];
    const strategies = [];
    for (let i = 0; i < strat.length; i += 10) {
      const batch = strat.slice(i, i + 10);
      const results = await this.strategiaService.getStrategyGQL(batch);
      strategies.push(...results);
    }
    this.estPer(strategies);
  }
  /** Clasificación en las cuator tablas */
  private estPer(array: any) {
    var aux = [], aux2 = [];
    for (const est of array) {
      for (const obj of this.objetivos) {
        if (est.objectives.length !== 0 && Number(est.objectives[0].id) === Number(obj.id)) {
          aux.push(est);
          break;
        }
      }
    }
    this.estrategia = [];
    aux = this.ordenarPerspe(aux);
    this.estrategia = aux;
  }
  private proyPer() {
    var auxProyectos = [];
    for(const est of this.estrategia){
      const proyectosEstrategia = est.projects.map( p => {
        return {
          ...p,
          strategies: [
            est
          ]
        }
      });

      proyectosEstrategia.forEach(p => {
        if(!auxProyectos.find(exPr => Number(exPr.id) === Number(p.id))){
          auxProyectos.push(p)
        }
      });
    }

    this.proyecto = [];
    auxProyectos = this.ordenarPerspe(auxProyectos);
    this.proyecto = [].concat(auxProyectos);
  }

  /* Agregado de elementos */
  private agregadoNuevos() {
    for (const per of this.diccionarioEst) {
      var est = [], pro = [];
      for (const obj of per.objetivos) {
        const ex = this.estrategia.filter(e => Number(e.objectives[0].id) === Number(obj.id));
        est = est.concat(ex);
        const pr = this.proyecto.filter(e => Number(e.objectives[0]?.id) === Number(obj.id));
        pro = pro.concat(pr);
      }
      per.proyectos = pro;
      per.estrategias = est;
    }
  }

  /** Decision de si guarda o no */
  public async alertas(aler: any, ele?: any) {
    if (aler === 'editar') {
      this.guardarEdit();
    } else if (aler === 'guardar') {
      this.almacenarD();
    } else if (aler === 'eliminar') {
      const result = await messages.confirmationSave(
        this.translate.instant('gestion.formulacion.alineamiento.confEliminar'),
        this.translate.instant('gestion.formulacion.alineamiento.elimProyecto'),
        this.translate
      );
      if (result) {
        this.eliminarele(ele);
      }
    }
  }

  /** Almacenamiento de datos */
  public async almacenarD() {
    messages.messageSaving(this.translate.instant('acciones.guardandoRes'),this.translate.instant('acciones.espera'))
    const estrategiaForm = this.formEst.value;
    const proyectoForm = this.formProg.value;

    const estrategia = new Estrategias();
    estrategia.name = estrategiaForm.inputName.trim();
    estrategia.objetiveId = [Number(estrategiaForm.selectObjetivos)];

    const proyec = new Proyectos();
    proyec.nombre = proyectoForm.inputNamePro.trim();
    proyec.objetiveId = [Number(estrategiaForm.selectObjetivos)];
    proyec.description = proyectoForm.inputDesc.trim();
    proyec.responsibleId = Number(proyectoForm.liderSelect);
    proyec.ponderacion = 0;

    if (estrategia.name !== '' &&
      estrategia.objetiveId[0] &&
      proyec.nombre !== '' &&
      proyec.responsibleId &&
      !this.nombreExiste() &&
      !this.nombreExisteProg()
    ) {
      try {
        const res = await firstValueFrom(this.strategiaService.postEstrategias(estrategia));
        const est = { projects: [], objectives: estrategia.objetiveId.map(e => { return {id: `${e}`}}),...res };
        proyec.programaId = [Number(res.id)];
        const res2 = await firstValueFrom(this.proyectosService.postProyectos(proyec));
        const pro = { activities: [], historicWeighing: [], ...res2, objectives: estrategia.objetiveId.map(e => { return {id: `${e}`}}) };
        pro.strategies = [{
          description: res.description,
          id: res.id,
          name: res.name
        }];
        est.projects = [JSON.parse(JSON.stringify(pro))];
        this.estrategia.push(est);
        this.estrategia = this.ordenarPerspe(this.estrategia);
        this.proyecto.push(pro);
        this.proyecto = this.ordenarPerspe(this.proyecto);
        Swal.close();
        messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
        this.agregadoNuevos();
      } catch (error) {
        let er = obtenerError.errorObt(error);
        Swal.close();
        messages.errorMessageGraph(er);
      }
      this.formEst.reset();
      this.formProg.reset();
      this.modal = false;
    } else {
      messages.messageGraph(
        this.translate.instant('swal.ingreseInformacion'),
        this.translate.instant(''),
        this.translate
      );
    }
  }

  public async guardarEdit() {
    messages.messageSaving(this.translate.instant('acciones.guardandoRes'),this.translate.instant('acciones.espera'))
    const estrategiaForm = this.formEst.value;
    const proyectoForm = this.formProg.value;

    // actualizar proyecto y estrategia
    this.estratt.name = estrategiaForm.inputNameEdit.trim();
    this.estratt.objetiveId = [Number(estrategiaForm.selectObjetivos)];

    if (this.proyectt) {
      this.proyectt.name = proyectoForm.inputNameProEdit?.trim() ?? '';
      this.proyectt.objetiveId = [Number(estrategiaForm.selectObjetivos)];
      this.proyectt.description = proyectoForm.inputDesc?.trim() ?? '';
      this.proyectt.responsibleId = Number(proyectoForm.liderSelect);
    }

    try {
      await firstValueFrom(this.strategiaService.patchEstrategia(this.estratt));
      if (this.proyectt) {
        await firstValueFrom(this.proyectosService.patchProyectos(this.proyectt));
      }else{
        const proyec = new Proyectos();
        proyec.nombre = proyectoForm.inputNameProEdit.trim();
        proyec.objetiveId = [Number(estrategiaForm.selectObjetivos)];
        proyec.descripcion = proyectoForm.inputDesc.trim();
        proyec.responsibleId = Number(proyectoForm.liderSelect);
        proyec.programaId = [Number(this.estratt.id)];
        const res2 = await firstValueFrom(this.proyectosService.postProyectos(proyec));
        const pro = { activities: [], historicWeighing: [], ...res2 };
        this.proyecto.push(pro);
        this.proyecto = this.ordenarPerspe(this.proyecto);
      }
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
      this.agregadoNuevos();

    } catch (error) {
      let er = obtenerError.errorObt(error['error'].message);
      messages.errorMessageGraph(er);
    }
    this.formEst.reset();
    this.formProg.reset();
    this.modal2 = false;
  }

  /** Eliminación de datos */
  private async eliminarele(ele: any) {
    messages.messageSaving(this.translate.instant('acciones.guardandoRes'),this.translate.instant('acciones.espera'))
    try {
      //eliiminar proyecto asociado primero
      for (const pro of ele.projects) {
        await lastValueFrom(this.proyectosService.deleteProyectos(pro));
        this.proyecto = this.proyecto.filter(p => p.id !== pro.id);
      }
      //eliminar estrategia
      await lastValueFrom(this.strategiaService.deleteEstrategias(ele));
      this.estrategia = this.estrategia.filter(e => e.id !== ele.id);
      this.agregadoNuevos();
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('swal.swalElimino'))
    } catch (error) {
      let er = obtenerError.errorObt(error['error'].message);
      Swal.close();
      messages.errorMessageGraph(er);
    }
  }

  /** Modal */
  //Abrir
  public open_modal(per: any) {
    this.idPers = per.id;

    this.formEst.controls['selectObjetivos'].setValue('default');
    this.formProg.controls['liderSelect'].setValue('default');
    this.modal = true;
  }
  public open_edit(est: any, per: any) {
    this.estratt = est;
    this.idPers = per.id;
    this.modal2 = true;

    let found = false;
    let proyecto = undefined;
    for (const per of this.diccionarioEst) {
      for (const pro of per.proyectos) {
        if (pro.strategies[0] !== undefined && this.estratt.id === pro.strategies[0].id) {
          proyecto = pro;
          found = true;
          break;
        }
      }
      if (found) break;
    }
    this.proyectt = proyecto;

    // Ahora setea los valores de los formularios
    this.formEst.controls['inputNameEdit'].setValue(this.estratt.name);
    this.formEst.controls['selectObjetivos'].setValue(this.estratt.objectives[0]?.id ?? '');

    if (proyecto) {
      this.formProg.controls['inputNameProEdit'].setValue(proyecto.name);
      this.formProg.controls['liderSelect'].setValue(proyecto.responsibleId);
      this.formProg.controls['inputDesc'].setValue(proyecto.description ?? '');
    } else {
      this.formProg.controls['inputNameProEdit'].setValue('');
      this.formProg.controls['liderSelect'].setValue('');
      this.formProg.controls['inputDesc'].setValue('');
    }
  }
  //Cerrar
  public closeModal() {
    this.modal = false;
    this.modal2 = false;

    this.formEst.reset();
    this.formProg.reset();
  }
  /** Comprobación de guardado */
  public puede_guardar() {
    const estrategiaForm = this.formEst.value;
    const proyectoForm = this.formProg.value;

    if (
      estrategiaForm.inputName?.trim() !== '' &&
      estrategiaForm.selectObjetivos && estrategiaForm.selectObjetivos !== 'default' &&
      proyectoForm.inputNamePro?.trim() !== '' &&
      proyectoForm.liderSelect && proyectoForm.liderSelect !== 'default' &&
      !this.nombreExiste() &&
      !this.nombreExisteProg()
    ) {
      return '';
    }
    return 'w3-disabled';
  }

  public puede_guardarEdit() {
    const estrategiaForm = this.formEst.value;
    const proyectoForm = this.formProg.value;

    if (
      estrategiaForm.inputNameEdit?.trim() !== '' &&
      estrategiaForm.selectObjetivos &&
      proyectoForm.inputNameProEdit?.trim() !== '' &&
      proyectoForm.liderSelect &&
      !this.nombreExiste() &&
      !this.nombreExisteProg()
    ) {
      return '';
    }
    return 'w3-disabled';
  }

  /** Metodos de escritura */
  public obtObj(obje: any) {
    var objetivos = '';
    for (const objet of obje.objectives) {
      for (const obj of this.objetivos) {
        if (Number(objet.id) === Number(obj.id)) {
          if (objetivos === '') {
            objetivos += obj.nombre;
          } else {
            objetivos += ', ' + obj.nombre;
          }
        }
      }
    }
    return objetivos;
  }

  /**------------------------------------------------------------------------------------------------*/
  /** Exportaciones */
  public exportar_excel() {
    let titulo = this.translate.instant('gestion.formulacion.alineamiento.tituloExcel');
    let titulosPers = []
    let headersPersp = []
    let contenidoTabla = []
    for (let i = 0; i < this.diccionarioEst.length; i++) {
      titulosPers.push(this.diccionarioEst[i].perspectiva.nombre)
      headersPersp.push([
        '#',
        this.translate.instant('gestion.formulacion.alineamiento.colObjetivo'),
        this.translate.instant('gestion.formulacion.alineamiento.colProgramas'),
      ]);
      let c = []
      for (let j = 0; j < this.diccionarioEst[i].estrategias.length; j++) {
        c.push([
          'P'.concat((j + 1).toString()),
          this.obtObj(this.diccionarioEst[i].estrategias[j]),
          this.diccionarioEst[i].estrategias[j].name,
        ])
      }
      contenidoTabla.push(c)
    }
    this.excelService.generateExcelAlineamientoEstrategicoFormulacion(titulo, titulosPers, headersPersp, contenidoTabla, "alineamiento_estrategico");
  }
  /** Comprobación de que el nombre no exista*/
  private nombreDuplicidad(): ValidatorFn {
    return (formGroup: FormGroup) => {
      var nombre = ""
      if (this.modal) {
        nombre = formGroup.get('inputName')?.value?.trim() ?? '';
      } else if (this.modal2) {
        nombre = formGroup.get('inputNameEdit')?.value?.trim() ?? '';
      }
      const existe = this.estrategia.find(element => {
        if (this.modal2) {
          return (procesamiento.procesamiento_Texto(element.name).toLowerCase().trim() === nombre.toLowerCase().trim() && element.id !== this.estratt.id);
        }
        return (procesamiento.procesamiento_Texto(element.name).toLowerCase().trim() === nombre.toLowerCase().trim());
      });
      if (existe) return { isValid: true };

      return null;
    };
  }

  public clickFuera(event, modal) {
    if (event.target === document.getElementById(modal)) {
      document.getElementById(modal).classList.add('moveShake');
      setTimeout(() => {
        document.getElementById(modal).classList.remove('moveShake');
      }, 600);
    }
  }

  public nombreExiste(): boolean {
    return this.formEst.hasError('isValid');
  }
  private nombreDuplicidadProg(): ValidatorFn {
    return (formGroup: FormGroup) => {
      let nombre = formGroup.get('inputNameProEdit')?.value?.trim() ?? '';
      const existe = this.proyecto.find(element => {
        if (this.modal2 && this.proyectt) {
          return (
            procesamiento.procesamiento_Texto(element.name).toLowerCase() === nombre.toLowerCase() &&
            Number(element.id) !== Number(this.proyectt.id)
          );
        }
        return procesamiento.procesamiento_Texto(element.name).toLowerCase() === nombre.toLowerCase();
      });
      if (existe) return { isValid: true };
      return null;
    };
  }
  public nombreExisteProg(): boolean {
    return this.formProg.hasError('isValid');
  }
}
